import JobPostApi from "../../api/clientJobPost";

export const saveJobPost = ({ state }) => JobPostApi.saveJobPost(state.jobPost);

export const getJobPost = async (context, { id }) => {
  const { data } = await JobPostApi.getJobPost(id);
  context.commit("setJobPostDetail", data.jobPost);
};

export const getJobPostShift = async (context, { jobPostId, id }) => {
  const { data } = await JobPostApi.getJobPostShift({ jobPostId, id });
  context.commit("setJobPostShiftDetail", data.shift);
};

export const acceptJobPostShift = async (
  context,
  { jobPostId, id, carers }
) => {
  await JobPostApi.acceptJobPostShift({ jobPostId, id, carers });
  await context.dispatch("getJobPostShift", { id, jobPostId });
};

export const rejectJobPostShift = async (
  context,
  { jobPostId, id, carers }
) => {
  await JobPostApi.rejectJobPostShift({ jobPostId, id, carers });
  await context.dispatch("getJobPostShift", { id, jobPostId });
};

export const acceptJobPost = async (context, { jobPostId, carers, role }) => {
  await JobPostApi.acceptJobPost({ jobPostId, carers, role });
  await context.dispatch("getJobPost", { id: jobPostId });
};

export const rejectJobPost = async (context, { jobPostId, carers }) => {
  await JobPostApi.rejectJobPost({ jobPostId, carers });
  await context.dispatch("getJobPost", { id: jobPostId });
};

export const cancelJobPost = async (context, payload) => {
  await JobPostApi.cancelJobPost(payload);
  await context.dispatch("getJobPost", { id: payload.jobPostId });
};

export const getJobPosts = () => JobPostApi.getJobPosts();
